import React from 'react';
import c from './img/asterisk.png';
import { Container } from 'react-bootstrap';
import './Permitforuseexceeds.css';


export const Permitforuseexceeds = () => (
  <Container>

    <div className="permit-page">


        <div className="permit-card">

          {/* כותרת הסבר */}
          <p className="permit-intro">
            על פי הנחיות היועץ המשפטי לממשלה בנוגע לרישוי עסקים במבנים שאינם מוסדרים,
            המחלקה לתכנון ולרישוי הנדסי בודקת את התאמת הבקשה לדיני התכנון והבנייה בנושאים הבאים:
          </p>

          {/* רשימת בדיקות */}
          <div className="permit-list-container">

            <div className="permit-list-item">
              <img src={c} alt="check" className="permit-list-icon" />
              <p className="permit-list-text">
                חוקיות המבנה והיתר הבנייה.
              </p>
            </div>

            <div className="permit-list-item">
              <img src={c} alt="check" className="permit-list-icon" />
              <p className="permit-list-text">
                במידה ואין היתר בנייה - נבדקת מידת העמידה בהגדרות המאפשרות קבלת רישיון עסק ללא היתר.
              </p>
            </div>

            <div className="permit-list-item">
              <img src={c} alt="check" className="permit-list-icon" />
              <p className="permit-list-text">
                התאמת השימוש בנכס לייעוד המבנה על פי היתר הבנייה ותוכנית בניין עיר (תב"ע).
              </p>
            </div>

          </div>

          <p className="permit-secondary-text">
            בדיקה זו מתבצעת במידה והשימוש המבוקש אינו תואם את היתר הבנייה או התב"ע הקיימת.
          </p>


          {/* =====================================================
              מאמר
          ===================================================== */}

          <div className="permit-article-section">

            <h2 className="permit-article-title">
              רישוי עסקים במבנים לא מוסדרים
            </h2>

            <p className="permit-article-intro">
              דיני תכנון ובנייה והנחיות היועמ"ש
            </p>

            <p className="permit-article-text">
              פתיחת עסק או חידוש רישיון במבנה שאינו מוסדר מבחינה תכנונית
              מציבים אתגר משפטי ומנהלי מורכב. כדי להסדיר סוגיה זו, קבע
              היועץ המשפטי לממשלה הנחיות ברורות המגדירות כיצד תבחן
              המחלקה לתכנון ולרישוי הנדסי את התאמת בקשת הרישוי
              לחוק התכנון והבנייה.
            </p>

            <p className="permit-article-text">
              מטרת הבדיקה היא למנוע מצב שבו רישיון העסק יכשיר בעקיפין
              עבירות בנייה חמורות, תוך מתן פתרונות מוגדרים לעסקים
              הפועלים במבנים מורכבים.
            </p>


            {/* שלושת צירי הבדיקה */}

            <div className="permit-article-block">

              <h3 className="permit-section-title">
                שלושת צירי הבדיקה של מחלקת ההנדסה
              </h3>

              <div className="permit-article-cards">

                {/* 01 */}
                <div className="permit-article-card">

                  <div className="permit-article-card-number">
                    01
                  </div>

                  <div>
                    <h4 className="permit-article-card-title">
                      חוקיות המבנה והיתר הבנייה
                    </h4>

                    <p className="permit-article-card-text">
                      המחלקה בוחנת האם המבנה הפיזי שבו מתוכנן לפעול העסק
                      הוקם כחוק והאם קיים עבורו היתר בנייה תקף ומלא
                      במערכות הרשות.
                    </p>
                  </div>

                </div>


                {/* 02 */}
                <div className="permit-article-card">

                  <div className="permit-article-card-number">
                    02
                  </div>

                  <div>
                    <h4 className="permit-article-card-title">
                      מבנים ללא היתר בנייה
                    </h4>

                    <p className="permit-article-card-text">
                      במידה ונמצא כי למבנה אין היתר בנייה מוסדר, נערכת
                      בדיקה של מידת העמידה בקריטריונים ובהגדרות המשפטיות
                      המיוחדות המאפשרות, במקרים חריגים בלבד, קבלת
                      רישיון עסק ללא קיומו של היתר.
                    </p>
                  </div>

                </div>


                {/* 03 */}
                <div className="permit-article-card">

                  <div className="permit-article-card-number">
                    03
                  </div>

                  <div>

                    <h4 className="permit-article-card-title">
                      התאמת השימוש לייעוד המבנה
                    </h4>

                    <p className="permit-article-card-text">
                      מתבצעת בדיקה של ההלימה בין סוג הפעילות של העסק לבין
                      הייעוד המקורי של המבנה כפי שנקבע בהיתר הבנייה
                      ובתוכנית בניין עיר (תב"ע).
                    </p>

                    <div className="permit-example-box">
                      <strong>לדוגמה:</strong>{' '}
                      הפעלת חנות מסחר במבנה המוגדר למגורים או לתעשייה.
                    </div>

                  </div>

                </div>

              </div>

            </div>


            {/* שימוש חורג */}

            <div className="permit-warning-box">

              <div className="permit-warning-icon">
                ⚠
              </div>

              <div>

                <h3 className="permit-warning-title">
                  חובת בעל העסק: היתר לשימוש חורג ותיקון 101
                </h3>

                <p className="permit-warning-text">
                  במקרים שבהם נמצאה אי-התאמה בין פעילות העסק המבוקשת
                  לבין היתר הבנייה או התב"ע, החוק אינו מאפשר הנפקת
                  רישיון באופן אוטומטי.
                </p>

                <p className="permit-warning-text">
                  בהתאם לרפורמה של תיקון 101 לחוק התכנון והבנייה,
                  בעל העסק נדרש לפעול להסדרת חריגות אלו באופן דיגיטלי.
                  על בעל העסק להגיש בקשה רשמית לקבלת היתר לשימוש חורג
                  באמצעות המערכת הארצית המקוונת של מנהל התכנון.
                </p>

              </div>

            </div>


            {/* זמן קבלת היתר */}

            <div className="permit-article-block">

              <h3 className="permit-section-title">
                כמה זמן לוקח לקבל היתר לשימוש חורג?
              </h3>

              <p className="permit-article-text">
                תהליך קבלת ההיתר דורש סבלנות רבה, ומשך הזמן הממוצע נע
                לרוב בין <strong>6 ל־12 חודשים</strong>, בהתאם למורכבות
                הבקשה ולעומס בוועדה המקומית.
              </p>

              <div className="permit-steps">

                <div className="permit-step">
                  <span className="permit-step-number">1</span>

                  <div>
                    <strong className="permit-step-title">
                      הכנת תוכניות
                    </strong>

                    <p className="permit-step-text">
                      הכנת תוכניות על ידי אדריכל מוסמך.
                    </p>
                  </div>
                </div>


                <div className="permit-step">
                  <span className="permit-step-number">2</span>

                  <div>
                    <strong className="permit-step-title">
                      פרסום הבקשה
                    </strong>

                    <p className="permit-step-text">
                      פרסום הבקשה ומתן אפשרות להתנגדויות הציבור והשכנים,
                      בהתאם להוראות החוק.
                    </p>
                  </div>
                </div>


                <div className="permit-step">
                  <span className="permit-step-number">3</span>

                  <div>
                    <strong className="permit-step-title">
                      דיון בוועדה
                    </strong>

                    <p className="permit-step-text">
                      דיון בוועדה המקומית לתכנון ובנייה וקבלת החלטה.
                    </p>
                  </div>
                </div>

              </div>

            </div>


            {/* סיכונים */}

            <div className="permit-danger-section">

              <h3 className="permit-danger-title">
                סיכונים וסנקציות: מה קורה אם פועלים ללא היתר תואם?
              </h3>

              <p className="permit-article-text">
                הפעלת עסק בסטייה מהיתר הבנייה או מהתב"ע ללא אישור
                לשימוש חורג עלולה להוביל להליכי אכיפה ולסנקציות
                בהתאם לחוק התכנון והבנייה.
              </p>

              <div className="permit-danger-list">

                <div className="permit-danger-item">
                  <span>●</span>

                  <div>
                    <strong>קנסות כספיים</strong>

                    <p>
                      קנסות מנהליים וקנסות נוספים בהתאם להוראות הדין.
                    </p>
                  </div>
                </div>


                <div className="permit-danger-item">
                  <span>●</span>

                  <div>
                    <strong>צווים משפטיים ומינהליים</strong>

                    <p>
                      הליכי אכיפה העלולים לכלול צווים להפסקת פעילות
                      והליכים משפטיים.
                    </p>
                  </div>
                </div>


                <div className="permit-danger-item">
                  <span>●</span>

                  <div>
                    <strong>פגיעה בהליך רישוי העסק</strong>

                    <p>
                      אי-הסדרת השימוש עלולה למנוע את קבלת רישיון העסק
                      או היתר זמני.
                    </p>
                  </div>
                </div>

              </div>

            </div>


            {/* רישוי זמין */}

            <div className="permit-system-box">

              <div className="permit-system-header">

                <div className="permit-system-icon">
                  💻
                </div>

                <div>
                  <h3 className="permit-system-title">
                    מדריך קצר: הגשת בקשה במערכת "רישוי זמין"
                  </h3>

                  <p className="permit-system-subtitle">
                    שלבי התהליך להסדרת הבקשה באופן מקוון
                  </p>
                </div>

              </div>


              <div className="permit-system-steps">

                <div className="permit-system-step">

                  <span className="permit-system-number">
                    01
                  </span>

                  <div>
                    <strong>
                      הזדהות ממשלתית
                    </strong>

                    <p>
                      כניסה למערכת הרלוונטית באמצעות מערכת ההזדהות
                      הלאומית.
                    </p>
                  </div>

                </div>


                <div className="permit-system-step">

                  <span className="permit-system-number">
                    02
                  </span>

                  <div>
                    <strong>
                      מינוי עורך בקשה
                    </strong>

                    <p>
                      יש להסמיך במערכת עורך בקשה מורשה, כגון אדריכל,
                      מהנדס או הנדסאי בניין רשום, אשר ינהל ויגיש
                      את התיק בפועל.
                    </p>
                  </div>

                </div>


                <div className="permit-system-step">

                  <span className="permit-system-number">
                    03
                  </span>

                  <div>
                    <strong>
                      קליטת ובחינת התיק
                    </strong>

                    <p>
                      עורך הבקשה יעלה את המדידות, התוכניות ההנדסיות
                      והנימוקים התכנוניים, והתיק ינותב לגורם הרלוונטי
                      ברשות המקומית.
                    </p>
                  </div>

                </div>

              </div>

            </div>


            {/* סיכום */}

            <div className="permit-bottom-summary">

              <span className="permit-summary-icon">
                ✓
              </span>

              <p>
                <strong>חשוב:</strong>{' '}
                מומלץ לבדוק את מצב הנכס וההתאמה התכנונית שלו
                כבר בתחילת תהליך פתיחת העסק, כדי לזהות מראש
                בעיות שעלולות לעכב את קבלת הרישיון.
              </p>

            </div>

          </div>


          {/* התראה לתיקון 101 */}

          <div className="permit-final-warning">

            <span className="permit-final-warning-title">
              חשוב לדעת:
            </span>

            <p className="permit-final-warning-text">
              על פי <strong>תיקון 101</strong>, בעל העסק נדרש להגיש בקשה
              לקבלת היתר לשימוש חורג באמצעות המערכת הארצית של
              "רישוי זמין".
            </p>

          </div>

        </div>


    </div>

  </Container>
);